/**
 * importengine domain — cache invalidation registry.
 *
 * The import wizard drives most of its state through XState, not React
 * Query — the only cached query is the import-previews list on the
 * previews page. So the only wrapped mutation that needs declarative
 * invalidation is `deleteImportPreview`; the state-machine steps
 * (create / set-* / validate / merge) are called imperatively and don't
 * touch the React Query cache.
 *
 * Consumed by `hooks.ts` via `useInvalidatingMutation`. The compiler
 * enforces that every `ImportengineMutationId` has a registry entry.
 */

import type { QueryKey } from '@tanstack/react-query'

import type { InvalidationRule } from '../invalidation/useInvalidatingMutation'
import { listImportPreviewsQueryKey } from '../generated/hooks/importengineController'

export type ImportengineMutationId = 'deleteImportPreview'

/** Query keys every import-preview mutation should invalidate. */
export function commonImportPreviewInvalidations(): QueryKey[] {
  return [listImportPreviewsQueryKey()]
}

export const invalidationRegistry: Record<
  ImportengineMutationId,
  InvalidationRule<any>
> = {
  deleteImportPreview: {
    invalidates: () => commonImportPreviewInvalidations(),
  },
}
